import { FormData } from '../types';

export const FORM_NAME = 'VIRTUAL_CARD_UPGRADE_FORM'; // имя формы
export const FORM_FIELDS = {
  FIRST_NAME: 'firstName',
  MIDDLE_NAME: 'middleName',
  LAST_NAME: 'lastName',
  BIRTH_DATE: 'birthDate',
  DOCUMENT_SERIES: 'documentSeries',
  DOCUMENT_NUMBER: 'documentNumber',
  DOCUMENT_ISSUE_DATE: 'documentIssueDate',
  DOCUMENT_UNIT_CODE: 'documentUnitCode',
  SNILS: 'snils',
  INN: 'inn',
  // Я не являюсь налоговым резидентом других стран, кроме РФ,
  // а место моего рождения — не США
  TAX_OK: 'taxOk',
} as const; // названия полей

export const INITIAL_VALUES: Partial<FormData> = {
  taxOk: true,
};

export const INN_FIELDS = [
  FORM_FIELDS.FIRST_NAME,
  FORM_FIELDS.LAST_NAME,
  FORM_FIELDS.BIRTH_DATE,
  FORM_FIELDS.DOCUMENT_NUMBER,
];

export const NAME_REGEXP = /^[а-яёА-ЯЁ][а-яёА-ЯЁ\s\-']*$/i;
export const NUMBER_REGEXP = /^\d{10}$/;

export const FORM_FIELDS_LIST = [
  FORM_FIELDS.FIRST_NAME,
  FORM_FIELDS.MIDDLE_NAME,
  FORM_FIELDS.LAST_NAME,
  FORM_FIELDS.BIRTH_DATE,
  FORM_FIELDS.DOCUMENT_SERIES,
  FORM_FIELDS.DOCUMENT_NUMBER,
  FORM_FIELDS.DOCUMENT_ISSUE_DATE,
  FORM_FIELDS.DOCUMENT_UNIT_CODE,
];
